<div [hidden]="onIndex != 0" @fade3 class="dialog-container" >
  <div class="ribbon-container" *ngIf="language == 'en'">
    <img class="ribbon-img" src="/assets/image/gamification/ribbon.png"/>
  </div>
  <div class="ribbon-container" *ngIf="language == 'bm'">
    <img class="ribbon-img2" src="/assets/image/gamification/ribbon-bm.png"/>
  </div>
  <div class="dialog-header">
    <div>{{"common.tapAndClaim" | translate}}</div>
  </div>

  <div class="dialog-header-description">
    <div>{{"common.moneyBagDesc-1" | translate}}</div>
    <div>{{"common.moneyBagDesc-2" | translate}}</div>
    <br>
  </div>

  <div class="grid-container" *ngIf="!mobileView">
    <div class="item">
      <img src="/assets/image/gamification/money-bag.png" (click)="onImageClick()"/>
    </div>
    <div class="item">
      <img src="/assets/image/gamification/money-bag.png" (click)="onImageClick()"/>
    </div>
    <div class="item">
      <img src="/assets/image/gamification/money-bag.png" (click)="onImageClick()"/>
    </div>
    <div class="item">
      <img src="/assets/image/gamification/money-bag.png" (click)="onImageClick()"/>
    </div>
    <div class="item">
      <img src="/assets/image/gamification/money-bag.png" (click)="onImageClick()"/>
    </div>
    <div class="item">
      <img src="/assets/image/gamification/money-bag.png" (click)="onImageClick()"/>
    </div>
  </div>
  <div class="grid-container-mobile" *ngIf="mobileView">
    <div class="item">
      <img src="/assets/image/gamification/money-bag-inline.png" (click)="onImageClick()"/>
    </div>
    <div class="item">
      <img src="/assets/image/gamification/money-bag-inline.png" (click)="onImageClick()"/>
    </div>
  </div>
</div>

<div [hidden]="onIndex != 1" @fade3 class="dialog-container" >
  <div class="ribbon-container" *ngIf="language == 'en'">
    <img class="ribbon-img" src="/assets/image/gamification/ribbon.png"/>
  </div>
  <div class="ribbon-container" *ngIf="language == 'bm'">
    <img class="ribbon-img2" src="/assets/image/gamification/ribbon-bm.png"/>
  </div>
  <div class="dialog-header">
  </div>
  <div class="dialog-header">
  </div>
  <div class="dialog-header">
  </div>
  <div class="dialog-header-description">
    <div class="container-div">
      <div class="bottom-div">
        <img [@fade]="toogle"  
             (@fade.done)="onFade($event)"  
             [src]="imageArray[count % imageArray.length]">
      </div>
      <div class="top-div">
        <img [@fade2]="toogle2"  
        (@fade2.done)="onFade2($event)"  
        [src]="imageArray2[count2%imageArray2.length]">
      </div>
    </div>
  </div>
</div>

<div [hidden]="onIndex != 2" @fade3 class="dialog-container" >
  <div class="ribbon-container" *ngIf="language == 'en'">
    <img class="ribbon-img" src="/assets/image/gamification/ribbon.png"/>
  </div>
  <div class="ribbon-container" *ngIf="language == 'bm'">
    <img class="ribbon-img2" src="/assets/image/gamification/ribbon-bm.png"/>
  </div>
  <div class="dialog-header">
    <div>{{"common.tapAndClaim" | translate}}</div>
  </div>

  <div class="dialog-header-description">
    <div><span >{{"common.moneyBagDesc-3" | translate}}</span></div>
    <div><span class="discount-amount">RM{{this.discountAmount}}!</span></div>

  </div>

  <div class="dialog-header-description" >
    <div class="item-code">
      <img src="/assets/image/gamification/money-bag-voucher.png"/>
    </div>
  </div>

  <div class="dialog-bottom-description">
    <div>{{"common.moneyBagDesc-4" | translate}}</div>
    <div class="yellow-email"><b>{{data.email}}</b></div>
    <div><button class="btn-close"
      mat-flat-button (click)="onClose()">{{"common.moneyBagClose" | translate}}</button></div>
  </div>
</div>
